module.exports = __webpack_public_path__ + "static/media/award1.ab0ada0a.png";